import React from 'react'
import { Box, Typography } from '@mui/material'

const PresentationViewer = ({ date, slides = [] }) => {
  const hasSlides = Array.isArray(slides) && slides.length > 0

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '24px' }}>
      <Box sx={{ borderBottom: '1px solid darkgrey', width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Typography
          sx={{
            fontSize: '14px',
          }}
        >
          {date}
        </Typography>
      </Box>

      {hasSlides &&
        slides.map((slide, index) => (
          <Box
            key={slide.src || index}
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              position: 'relative',
              zIndex: 2,
            }}
          >
            <Box
              component="img"
              src={slide.src}
              alt={`Slide ${index + 1}`}
              loading="lazy"
              sx={{
                width: '100%',
                maxWidth: '960px',
                display: 'block',
                backgroundColor: 'rgba(0,0,0,0.45)',
                borderRadius: '12px',
              }}
            />
          </Box>
        ))}
    </Box>
  )
}

export default PresentationViewer
